// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tippy-box[data-theme~=light-border] {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 8, 16, 0.15);
  color: #333;
  box-shadow: 0 4px 14px -2px rgba(0, 8, 16, 0.08);
}

.tippy-box[data-theme~=light-border] > .tippy-backdrop {
  background-color: #fff;
}

.tippy-box[data-theme~=light-border] > .tippy-arrow:after, .tippy-box[data-theme~=light-border] > .tippy-svg-arrow:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.tippy-box[data-theme~=light-border] > .tippy-arrow:after {
  border-color: transparent;
  border-style: solid;
}

.tippy-box[data-theme~=light-border][data-placement^=top] > .tippy-arrow:before {
  border-top-color: #fff;
}

.tippy-box[data-theme~=light-border][data-placement^=top] > .tippy-arrow:after {
  border-top-color: rgba(0, 8, 16, 0.2);
  border-width: 7px 7px 0;
  top: 17px;
  left: 1px;
}

.tippy-box[data-theme~=light-border][data-placement^=top] > .tippy-svg-arrow > svg {
  top: 16px;
}

.tippy-box[data-theme~=light-border][data-placement^=top] > .tippy-svg-arrow:after {
  top: 17px;
}

.tippy-box[data-theme~=light-border][data-placement^=bottom] > .tippy-arrow:before {
  border-bottom-color: #fff;
  bottom: 16px;
}

.tippy-box[data-theme~=light-border][data-placement^=bottom] > .tippy-arrow:after {
  border-bottom-color: rgba(0, 8, 16, 0.2);
  border-width: 0 7px 7px;
  bottom: 17px;
  left: 1px;
}

.tippy-box[data-theme~=light-border][data-placement^=bottom] > .tippy-svg-arrow > svg {
  bottom: 16px;
}

.tippy-box[data-theme~=light-border][data-placement^=bottom] > .tippy-svg-arrow:after {
  bottom: 17px;
}

.tippy-box[data-theme~=light-border][data-placement^=left] > .tippy-arrow:before {
  border-left-color: #fff;
}

.tippy-box[data-theme~=light-border][data-placement^=left] > .tippy-arrow:after {
  border-left-color: rgba(0, 8, 16, 0.2);
  border-width: 7px 0 7px 7px;
  left: 17px;
  top: 1px;
}

.tippy-box[data-theme~=light-border][data-placement^=left] > .tippy-svg-arrow > svg {
  left: 11px;
}

.tippy-box[data-theme~=light-border][data-placement^=left] > .tippy-svg-arrow:after {
  left: 12px;
}

.tippy-box[data-theme~=light-border][data-placement^=right] > .tippy-arrow:before {
  border-right-color: #fff;
  right: 16px;
}

.tippy-box[data-theme~=light-border][data-placement^=right] > .tippy-arrow:after {
  border-width: 7px 7px 7px 0;
  right: 17px;
  top: 1px;
  border-right-color: rgba(0, 8, 16, 0.2);
}

.tippy-box[data-theme~=light-border][data-placement^=right] > .tippy-svg-arrow > svg {
  right: 11px;
}

.tippy-box[data-theme~=light-border][data-placement^=right] > .tippy-svg-arrow:after {
  right: 12px;
}

.tippy-box[data-theme~=light-border] > .tippy-svg-arrow {
  fill: #fff;
}

.tippy-box[data-theme~=light-border] > .tippy-svg-arrow:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 16px 6px;
  width: 16px;
  height: 6px;
}`, "",{"version":3,"sources":["webpack://./node_modules/tippy.js/themes/light-border.css"],"names":[],"mappings":"AAAA;EAAqC,sBAAA;EAAsB,4BAAA;EAA4B,sCAAA;EAAkC,WAAA;EAAW,gDAAA;AAMpI;;AANgL;EAAqD,sBAAA;AAUrO;;AAV2P;EAAoH,WAAA;EAAW,kBAAA;EAAkB,WAAA;AAgB5Y;;AAhBuZ;EAAwD,yBAAA;EAAyB,mBAAA;AAqBxe;;AArB2f;EAA8E,sBAAA;AAyBzkB;;AAzB+lB;EAA6E,qCAAA;EAAiC,uBAAA;EAAuB,SAAA;EAAS,SAAA;AAgC7uB;;AAhCsvB;EAA+E,SAAA;AAoCr0B;;AApC80B;EAAiF,SAAA;AAwC/5B;;AAxCw6B;EAAiF,yBAAA;EAAyB,YAAA;AA6ClhC;;AA7C8hC;EAAgF,wCAAA;EAAoC,uBAAA;EAAuB,YAAA;EAAY,SAAA;AAoDrrC;;AApD8rC;EAAkF,YAAA;AAwDhxC;;AAxD4xC;EAAoF,YAAA;AA4Dh3C;;AA5D43C;EAA+E,uBAAA;AAgE38C;;AAhEk+C;EAA8E,sCAAA;EAAkC,2BAAA;EAA2B,UAAA;EAAU,QAAA;AAuEvnD;;AAvE+nD;EAAgF,UAAA;AA2E/sD;;AA3EytD;EAAkF,UAAA;AA+E3yD;;AA/EqzD;EAAgF,wBAAA;EAAwB,WAAA;AAoF75D;;AApFw6D;EAA+E,2BAAA;EAA2B,WAAA;EAAW,QAAA;EAAQ,uCAAA;AA2FriE;;AA3FwkE;EAAiF,WAAA;AA+FzpE;;AA/FoqE;EAAmF,WAAA;AAmGvvE;;AAnGkwE;EAAsD,UAAA;AAuGxzE;;AAvGk0E;EAA4D,yDAAA;EAA6U,yBAAA;EAAyB,WAAA;EAAW,WAAA;AA8G/uF","sourcesContent":[".tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
